import i18next from 'i18next'

import { getFormedEltTranslation } from './getFormedEltTranslation'
import { getPreviousQuarterAndYear } from './getPreviousYearAndQuarter'

export const getEltCoverageQuartersLabel = (quarter: number) => {
  if (quarter === 4) return i18next.t('jbp-financial-cockpit-period-full-year')
  const key = quarter === 1 ? 'coverage-quarter' : 'coverage-quarters'
  return i18next.t(getFormedEltTranslation(key)).replaceAll('{quarter}', String(quarter))
}

export const getEltCoverageLabel = (fYear: number, fQuarter: number) => {
  if (!fYear || !Number.isInteger(fQuarter) || fQuarter < 1 || fQuarter > 4) return '—'
  const { year, quarter } = getPreviousQuarterAndYear(fYear, fQuarter)
  return formatEltCoverageLabel(year, quarter)
}

export const formatEltCoverageLabel = (year: number, quarter: number) => {
  return i18next
    .t(getFormedEltTranslation('coverage-period'))
    .replaceAll('{fYear}', String(year).slice(-2))
    .replaceAll('{quarters}', getEltCoverageQuartersLabel(quarter))
}
